import { render, staticRenderFns } from "./floorvalue.vue?vue&type=template&id=4d874e78&"
import script from "./floorvalue.vue?vue&type=script&lang=js&"
export * from "./floorvalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d874e78')) {
      api.createRecord('4d874e78', component.options)
    } else {
      api.reload('4d874e78', component.options)
    }
    module.hot.accept("./floorvalue.vue?vue&type=template&id=4d874e78&", function () {
      api.rerender('4d874e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8LF8uzFnt2MuK/JS/comp/floorvalue.vue"
export default component.exports